/**
 * User tag from GET /api/user/tags, normalized for app use.
 * A selected tag from this endpoint is sent to supported surfaces as the
 * `InvestorTagId` query parameter. A tag whose `rights[]` include `Edit`/`Delete`
 * is a personal ("My tags") tag; otherwise it is a firm ("My firm") tag.
 */
export interface UserTag {
  tagId: number;
  name: string;
  rights: string[];
}

export const USER_TAG_EDIT_RIGHT = 'Edit';
export const USER_TAG_DELETE_RIGHT = 'Delete';
export const USER_TAG_ASSIGN_RIGHT = 'Assign';

export function userTagCanEdit(tag: UserTag): boolean {
  return tag.rights.includes(USER_TAG_EDIT_RIGHT);
}

export function userTagCanDelete(tag: UserTag): boolean {
  return tag.rights.includes(USER_TAG_DELETE_RIGHT);
}

/** True when the user may add/remove accounts on this tag (Assign or Edit). */
export function userTagCanAssign(tag: UserTag): boolean {
  return tag.rights.includes(USER_TAG_ASSIGN_RIGHT) || userTagCanEdit(tag);
}
